import { useState } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/dagkrcbep053ijub2c90";

export default function Newsletter() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [message, setMessage] = useState("");
  const [pending, setPending] = useState(false);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    // honeypot guard
    const honeypot = String(formData.get("contact_alt") ?? "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("已收到，稍后为你推送本期瓜报，请留意邮箱。");
      form.reset();
      return;
    }

    formData.delete("contact_alt");
    setPending(true);
    setStatus("idle");
    setMessage("");

    try {
      const res = await fetch(SUBMIT_ADDR, {
        method: "POST",
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });
      const text = await res.text();
      let parsed: Record<string, unknown> = {};
      try {
        parsed = JSON.parse(text) as Record<string, unknown>;
      } catch {
        /* ignore */
      }
      const meta = (parsed?.meta ?? {}) as Record<string, unknown>;
      const serverMsg = String(meta?.message ?? parsed?.message ?? meta?.detail ?? text ?? "");
      const ok = res.ok && String(parsed?.code ?? "") === "OK" && !serverMsg.includes("spam");
      if (ok) {
        setStatus("success");
        setMessage("订阅成功！每期复盘上线时，我们会第一时间推送到你的邮箱。");
        form.reset();
      } else {
        setStatus("error");
        setMessage(serverMsg || "暂时无法完成订阅，请稍后再试或直接邮件联系我们。");
      }
    } catch {
      setStatus("error");
      setMessage("网络似乎开小差了，请稍后再试一次。");
    } finally {
      setPending(false);
    }
  };

  return (
    <div className="mx-auto max-w-xl">
      <form
        id="newsletter-form"
        data-readdy-form="昨日吃瓜订阅"
        onSubmit={handleSubmit}
        className="flex flex-col gap-3 sm:flex-row sm:gap-0"
        noValidate={false}
      >
        <input
          type="text"
          name="contact_alt"
          autoComplete="off"
          tabIndex={-1}
          aria-hidden="true"
          readOnly
          className="honeypot-guard"
        />
        <label htmlFor="nl-email" className="sr-only">
          邮箱地址
        </label>
        <input
          id="nl-email"
          type="email"
          name="email"
          required
          placeholder="输入你的邮箱"
          className="w-full rounded-full border border-background-300 bg-background-50 px-5 py-3 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-500 focus:border-primary-500 sm:rounded-r-none sm:border-r-0"
        />
        <button
          type="submit"
          disabled={pending}
          className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60 sm:rounded-l-none"
        >
          {pending ? "订阅中…" : "订阅瓜报"}
        </button>
      </form>
      {status === "success" && (
        <p className="mt-3 flex items-center gap-2 rounded-lg bg-accent-100 px-4 py-2.5 text-sm text-accent-900">
          <i className="ri-checkbox-circle-line" aria-hidden="true" />
          {message}
        </p>
      )}
      {status === "error" && (
        <p className="mt-3 flex items-center gap-2 rounded-lg bg-primary-100 px-4 py-2.5 text-sm text-primary-900">
          <i className="ri-error-warning-line" aria-hidden="true" />
          {message}
        </p>
      )}
      <p className="mt-3 text-xs text-foreground-500">每周精选复盘直送邮箱，可随时退订。</p>
    </div>
  );
}